export default "__VITE_ASSET__Cfs5x189__"